import React, {Component} from "react";
import _ from "lodash";
import firebase, {config} from "../../lib/firebase";
import RaisedButton from 'material-ui/RaisedButton';
import Avatar from 'material-ui/Avatar';
import "./User.css";
import store from "../../lib/store";
import IconButton from 'material-ui/IconButton';
import ActionHome from 'material-ui/svg-icons/action/home';
import Clear from 'material-ui/svg-icons/content/clear';
import Upload from 'material-ui/svg-icons/action/backup';
import Dropzone from 'react-dropzone';

import 'whatwg-fetch';

require('es6-promise').polyfill();
window._ = _;

class User extends Component {

    constructor(props) {
        super(props);
        this.state = {
            display: null,
            photoURL: null,
            is_logined: false,
            this_user_id: this.props.id ? this.props.id : this.props.match.params.userId,
            situp: null
        };
        fetch(`${config.firebase.functionURL}/user?id=${this.state.this_user_id}`).then(res => {
            return res.json();
        }).then(function (result) {
            this.setState({displayName: result.displayName, photoURL: result.photoURL})
        }.bind(this));
        this.unsubscribe = store.subscribe(function () {
            this.setState({is_logined: store.getState().is_logined});
        }.bind(this))
        firebase.auth().onAuthStateChanged(function (user) {
            this.setState({is_logined: user === null ? false : true});
        }.bind(this));
    }


    componentWillUnmount() {
        this.unsubscribe();
    }

    componentDidMount() {
        this.checkSitUp();
    }

    checkSitUp() {
        firebase.auth().onAuthStateChanged(function (user) {
            if (user !== null && user.uid !== this.state.this_user_id) {
                firebase.database().ref(`/users/${user.uid}/mates/I_to_other/${this.state.this_user_id}`).once('value').then(function (sp) {
                    var situp;
                    if (sp.val() === 1) {
                        situp = store.getState().is_logined ?
                            <div style={{textAlign: 'center', 'paddingTop': '1.3rem'}}>
                                <RaisedButton label="옆자리에서 일어나기" onClick={function () {
                                    firebase.auth().onAuthStateChanged(function (user) {
                                        var updates = {};
                                        updates[`/users/${user.uid}/mates/I_to_other/${this.state.this_user_id}`] = null;
                                        firebase.database().ref().update(updates).then(function () {
                                            this.checkSitUp();
                                            window.location.reload();
                                        }.bind(this));
                                    }.bind(this));
                                }.bind(this)}/></div> : null;
                    } else {
                        situp = store.getState().is_logined ?
                            <div style={{textAlign: 'center', 'paddingTop': '1.3rem'}}>
                                <RaisedButton label="옆자리에 앉기" onClick={function () {
                                    firebase.auth().onAuthStateChanged(function (user) {
                                        var updates = {};
                                        updates[`/users/${user.uid}/mates/I_to_other/${this.state.this_user_id}`] = 1;
                                        firebase.database().ref().update(updates).then(function () {
                                            this.checkSitUp();
                                            window.location.reload();
                                        }.bind(this));
                                    }.bind(this));
                                }.bind(this)}/></div> : null;
                    }
                    this.setState({situp: situp});
                }.bind(this));
            }
        }.bind(this));
    }

    render() {
        let dropzone = null;
        if (this.state.is_logined) {
            dropzone = this.state.this_user_id === firebase.auth().currentUser.uid ?
                <div style={{height: 0}}><Dropzone onDrop={function (accepted, rejected) {
                    var storageRef = firebase.storage().ref();
                    var profileStorageRef = storageRef.child(`/users/${this.state.this_user_id}/profile`);
                    profileStorageRef.put(accepted[0]).then(function (sp) {
                        firebase.database().ref(`/users/${this.state.this_user_id}/photoURL`).set(sp.downloadURL).then(function (sp) {
                            this.setState({photoURL: sp.downloadURL})
                        }.bind(this, sp));
                    }.bind(this));
                }.bind(this)}
                                                   ref={(node) => {
                                                       this.dropzoneRef = node;
                                                   }}
                                                   acceptStyle={{position: 'absolute'}}
                                                   activeStyle={{}}
                                                   style={{position: 'absolute'}}
                /><IconButton
                    iconStyle={{
                        width: 60,
                        height: 60
                    }}
                    style={{
                        width: 120,
                        height: 120,
                        padding: 30,
                        position: 'relative',
                        right: -104,
                        top: -80
                    }}
                    onClick={function (dropzoneRef) {
                        this.dropzoneRef.open()
                    }.bind(this)}
                ><Upload/></IconButton></div> : null;

        }
        return <div className="User" style={{
            backgroundImage: `url(https://source.unsplash.com/collection/1489391/1920x1080)`,
            width: '100vw',
            height: '100vh',
            backgroundSize: 'cover'
        }}>
            <IconButton
                style={{position: 'absolute', left: 0}}
                href="/"
            >
                <ActionHome/>
            </IconButton>
            {this.props.match && this.props.match.params ? null : <IconButton
                iconStyle={{
                    width: 60,
                    height: 60
                }}
                style={{
                    width: 120,
                    height: 120,
                    padding: 30,
                    position: 'absolute',
                    right: 0,
                    top: 0
                }}
                onClick={function () {
                    store.dispatch({type: 'USER_PROFILE_CLOSE'});
                    store.dispatch({type: 'CAMPAIGN_INITIALIZE'});
                }}
            >
                <Clear/>
            </IconButton>}
            <div className="notice">
                {/*<ReactSVG
                    path={"/static/image/svg/chair/3.svg"}
                    style={{height: '30%', position:'absolute', right:"0", bottom:0}}
                />*/}
                <Avatar src={this.state.photoURL} backgroundColor="white" size={150}/>
                {dropzone}
                <span className="displayName" style={{fontSize: '1.6rem', marginTop: 12, height: "2.2rem"}}
                      onClick={function () {
                          if (this.state.is_logined && this.state.this_user_id === firebase.auth().currentUser.uid) {
                              let displayName = prompt("변경할 이름을 입력해주세요.", this.state.displayName);
                              firebase.database().ref(`/users/${this.state.this_user_id}/displayName`).set(displayName).then(function () {
                                  this.setState({displayName: displayName})
                              }.bind(this));
                          }
                      }.bind(this)}>{this.state.displayName}</span>
                {this.state.situp}
            </div>
        </div>
    }
}

export default User;


// WEBPACK FOOTER //
// ./src/container/user/User.js